import React from "react";
import BondNode from "components/BondTree/Node";
import DeviceAction from "./DeviceAction";
import DevicesCommands from "./DeviceCommands";
import Button from "react-bootstrap/Button";
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Row from "react-bootstrap/Row";
import {faTrashCan} from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function Device(props) {
    function deleteDevice() {
        if (window.confirm("Delete Device?"))
            props.bond.delete(props.path).then(() => {
                props.onDeviceDeleted();
            });
    }

    function customAttrComponent(attr, value) {
        switch (attr) {
            case "actions":
                return (
                    <li key={attr}>
                        {renderActions(value, props.bond, props.path)}
                    </li>
                );
            case "commands":
                return (
                    <DevicesCommands
                        key={attr}
                        bond={props.bond}
                        parentU={value["_"]}
                        path={props.path + attr + "/"}
                        label={attr}
                    />
                );
            default:
                return null;
        }
    }

    return (
        <BondNode
            {...props}
            customAttrComponent={customAttrComponent}
            extraComponents={[
                <li key="delete">
                    <Button onClick={() => deleteDevice()} variant={"outline-danger"}><FontAwesomeIcon
                        icon={faTrashCan}/> Delete</Button>
                </li>
            ]}
        />
    );
}

function renderActions(actions, bond, path, className) {
    if  (!actions)
        return "";
    className = className || "w-100 ps-0"
    let actionComponents = [];
    for (let action of actions)
        actionComponents.push(
            <DeviceAction
                key={action}
                bond={bond}
                action={action}
                path={`${path}actions/${action}`}
            />
        );
    return <Row className={className} key={path}><br/>
        <ButtonGroup vertical className={"actionsButtonGroup"}>
            <Button disabled variant={"secondary"}>
                Actions
            </Button>
            {actionComponents}
        </ButtonGroup>
    </Row>;
}

export default Device;
export {renderActions};
